import { combineReducers } from 'redux'
import deviceManagementSlice from '../slice/settings/device-management-slice'
import tillToTillShareSlice from '../slice/settings/till-to-till-share-slice'
import delivaryManagementSlice from '../slice/settings/delivary-management-slice'

const settingReducer = combineReducers({
  deviceManagement: deviceManagementSlice,
  tillToTillShare: tillToTillShareSlice,
  delivaryManagement: delivaryManagementSlice,
})

export default settingReducer
